import apiClient from "./apiService";
import { Grade, GradeQueryParams } from "../interfaces/Grade";

export default {
  async getGrades(url: string, params?: GradeQueryParams) {
    try {        
      const response = await apiClient.get(url, { params });
      return response;
    } catch (error) {
      console.error("Error fetching grades:", error);
      throw error; 
    }
  },
};
